/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { getCurrentInstance, computed, inject } from 'vue';
import { i as isBoolean_1 } from '../_chunks/dep-11ebe61f.mjs';
import '../_chunks/dep-6f3e4f56.mjs';
import '../_chunks/dep-b1060562.mjs';
import '../_chunks/dep-b333ab93.mjs';
import '../_chunks/dep-8049d2e0.mjs';

function useDisabled(context) {
  var currentInstance = getCurrentInstance();
  var componentDisabled = computed(function () {
    return currentInstance.props.disabled;
  });
  var formDisabled = inject("formDisabled", /* @__PURE__ */Object.create(null));
  return computed(function () {
    var _formDisabled$disable;
    if (isBoolean_1(context === null || context === void 0 ? void 0 : context.beforeDisabled.value)) return context.beforeDisabled.value;
    if (isBoolean_1(componentDisabled.value)) return componentDisabled.value;
    if (isBoolean_1(context === null || context === void 0 ? void 0 : context.afterDisabled.value)) return context.afterDisabled.value;
    if (isBoolean_1((_formDisabled$disable = formDisabled.disabled) === null || _formDisabled$disable === void 0 ? void 0 : _formDisabled$disable.value)) return formDisabled.disabled.value;
    return false;
  });
}

export { useDisabled };
//# sourceMappingURL=useDisabled.mjs.map
